import OrganizationDocuments from "@/components/organization/OrganizationDocuments";
import { createFileRoute } from "@tanstack/react-router";
import { requireFeature } from "@/lib/feature-gate";

export const Route = createFileRoute("/user/_layout/organization/documents")({
  beforeLoad: () => requireFeature("documents"),
  component: OrganizationDocuments,
});
